import ReactDOM from "react-dom/client";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import './App.css'
import reportWebVitals from "./reportWebVitals";
import MainRoutes from "./routes";
import App from "./App";
import "tw-elements";
import "bootstrap/dist/css/bootstrap.min.css";
import Providers from "./context/Provider";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Providers>
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/*" element={<MainRoutes />} />
      </Routes>
    </Providers>
  </BrowserRouter>
);

reportWebVitals();

